import {
  CustomerInvoiceEntityType,
  CustomerInvoiceProfile,
  CustomerInvoiceProfileFormErrors,
  CustomerInvoiceProfileFormValues,
  UpdateCustomerInvoiceProfileDto
} from '@/types/CustomerInvoiceProfile.interface';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Editable fields in the order the dialog shows them. */
export const PROFILE_EDITABLE_FIELDS: ReadonlyArray<
  keyof CustomerInvoiceProfileFormValues
> = [
  'name',
  'taxOffice',
  'email',
  'phone',
  'address',
  'buildingNumber',
  'district',
  'city',
  'postalCode'
];

export const toProfileFormValues = (
  profile: CustomerInvoiceProfile
): CustomerInvoiceProfileFormValues => ({
  name: profile.name ?? '',
  taxOffice: profile.taxOffice ?? '',
  address: profile.address ?? '',
  buildingNumber: profile.buildingNumber ?? '',
  district: profile.district ?? '',
  city: profile.city ?? '',
  postalCode: profile.postalCode ?? '',
  email: profile.email ?? '',
  phone: profile.phone ?? ''
});

/**
 * Validation for the edit dialog. Values are i18n keys so the component can
 * translate them. A VKN buyer (entityType COMPANY) must keep a tax office; an
 * individual (TCKN) buyer does not need one.
 */
export const validateProfileForm = (
  values: CustomerInvoiceProfileFormValues,
  entityType: CustomerInvoiceEntityType
): CustomerInvoiceProfileFormErrors => {
  const errors: CustomerInvoiceProfileFormErrors = {};
  if (!values.name.trim()) {
    errors.name = 'customerInvoiceProfiles.validation.name.required';
  }
  if (entityType === 'COMPANY' && !values.taxOffice.trim()) {
    errors.taxOffice = 'customerInvoiceProfiles.validation.taxOffice.required';
  }
  const email = values.email.trim();
  if (email && !EMAIL_PATTERN.test(email)) {
    errors.email = 'customerInvoiceProfiles.validation.email.invalid';
  }
  return errors;
};

/** PATCH body: only the fields that really changed, trimmed. */
export const buildProfileUpdateDto = (
  values: CustomerInvoiceProfileFormValues,
  original: CustomerInvoiceProfile
): UpdateCustomerInvoiceProfileDto => {
  const initial = toProfileFormValues(original);
  const dto: UpdateCustomerInvoiceProfileDto = {};
  PROFILE_EDITABLE_FIELDS.forEach((field) => {
    const next = values[field].trim();
    if (next !== initial[field].trim()) {
      dto[field] = next;
    }
  });
  return dto;
};
